import * as React from 'react';
import { useSelector } from 'react-redux';
import { useAtomValue } from 'jotai';
import { Trend } from '@components/common';
import { currentMetricsMetaSelector, supportedMetricsSelector } from '@store/common/selectors';
import { filterNAMetricsAtom } from '@src/atoms/page';
import { getMetricDisplayName } from '@utils/metrics';
import { WidgetNumberWrapper, MetricsCardTextWrapper, WidgetTitle } from '../styled';
import { getMetricTitle } from './improvement-opportunities-widget/utils';
import useSetSummaryExport from '../hooks/useSetSummaryExport';
import { getInvertedPercentageMetricByKey } from '@src/utils/metrics/metricHelpers';
import { getDodDiff } from '@src/components/metrics-panel-hz/utils/calculateDodTotal';

const MetricsWidget = ({
  data,
  dodData,
  selectedChartMetric,
  onWidgetCardClick,
  metricList,
  showTrend = false,
}) => {
  const allowedMetrics: Record<string, any> = useSelector(supportedMetricsSelector);
  const metricsToNA: string[] = useAtomValue(filterNAMetricsAtom);

  const allowedMetricList = metricList.filter(
    (metric) =>
      (metric in allowedMetrics ||
        getInvertedPercentageMetricByKey({ metricKey: metric }) in allowedMetrics) &&
      !metricsToNA.includes(metric),
  );

  const currentMetricsMeta = useSelector(currentMetricsMetaSelector);

  useSetSummaryExport({
    totals: data,
    dodTotals: dodData,
    category: { name: 'Audience Metrics Summary', metrics: allowedMetricList },
  });

  return (
    // <MetricsWidgetWrapper>
    <>
      {allowedMetricList.map((metricKey) => {
        const displayName = getMetricDisplayName({ metricKey });
        return (
          <MetricsCardTextWrapper
            key={metricKey}
            onClick={() => onWidgetCardClick(metricKey, data?.[metricKey])}
            highlight={metricKey === selectedChartMetric}
          >
            <WidgetTitle>{displayName}</WidgetTitle>
            <WidgetNumberWrapper>
              {getMetricTitle(metricKey, data?.[metricKey])}
              {showTrend && (
                <Trend
                  value={getDodDiff(data?.[metricKey], dodData[metricKey])}
                  style={{ textAlign: 'left', paddingLeft: 4 }}
                  reverse={currentMetricsMeta?.[metricKey]?.reverse}
                />
              )}
            </WidgetNumberWrapper>
          </MetricsCardTextWrapper>
        );
      })}
    </>
    // </MetricsWidgetWrapper>
  );
};

export default MetricsWidget;
